import React from 'react'
import { Typography, Box, Table, TableHead, TableRow, TableCell, CardMedia, TableBody, Button, Collapse, Stack, Paper, styled, Divider, TextField, makeStyles, Grid, FormControl } from '@mui/material';
import { useEffect, useState } from 'react';
import { getCompanyInfo, updateWebinf } from 'src/api';
import Swal from 'sweetalert2';

export default function CompanyInfo() {
    const [companyInfoInit, setCompanyInfoInit] = useState([])
    const [companyInfo, setCompanyInfo] = useState([])
    const [open, setOpen] = useState(false)
    useEffect(() => {
        async function fetchData() {
            const companyInfoData = await getCompanyInfo()
            let tempData = companyInfoData.results
            setCompanyInfoInit(companyInfoData.results)
            const info = tempData.map((office, index) => {
                const newOffice = { ...office }
                let convertedObject = {};
                delete newOffice.id
                if (index == 1) {
                    delete newOffice.email
                    delete newOffice.link1
                    delete newOffice.link2
                    delete newOffice.link3
                }
                Object.keys(newOffice).forEach(key => {
                    let value = newOffice[key];
                    if (key === 'link2' && typeof value === 'string' && value.startsWith('{')) {
                        try {
                            value = JSON.parse(value);
                        } catch (e) {
                            console.error("Error parsing link2:", e);
                        }
                    }
                    convertedObject[key] = {
                        value: value,
                        invalid: false,
                        msg: ""
                    };
                });
                return convertedObject
            })
            setCompanyInfo(info)
        }
        fetchData();

    }, [])

    function handleChange(value, id, name, subKey = null) {
        let infor = [...companyInfo]
        if (subKey) {
            if (typeof infor[id][name].value !== 'object') {
                infor[id][name].value = {};
            }
            infor[id][name].value = {
                ...infor[id][name].value,
                [subKey]: value
            };
        } else {
            infor[id][name].value = value
        }

        if (value.length == 0 && !subKey) {
            infor[id][name].invalid = true
            infor[id][name].msg = `${name} cannot be empty`
        } else {
            if (name == 'phone_num') {
                infor[id][name].value = value.replace(/\s/g, '')
                infor[id][name].invalid = !isValidPhoneNumber(infor[id][name].value)
                if (!infor[id][name].invalid) {
                    infor[id][name].msg = ``
                } else {
                    infor[id][name].msg = `Invalid phone number`
                }
            } else if (name == 'email') {
                infor[id][name].value = value.replace(/\s/g, '')
                infor[id][name].invalid = !isValidEmail(infor[id][name].value)
                if (!infor[id][name].invalid) {
                    infor[id][name].msg = ``
                } else {
                    infor[id][name].msg = `Invalid phone email address`
                }
            } else if (name.indexOf('link') > -1 && !subKey) {
                infor[id][name].value = value.replace(/\s/g, '')
                infor[id][name].invalid = !isValidWebsiteLink(infor[id][name].value)
                if (!infor[id][name].invalid) {
                    infor[id][name].msg = ``
                } else {
                    infor[id][name].msg = `Invalid website link`
                }
            } else {
                infor[id][name].invalid = false
                infor[id][name].msg = ``
            }
        }
        setCompanyInfo(infor)
    }
    async function handleUpdateWebinf(currCompanyInfo, companyInfoInit) {
        if (validateData(currCompanyInfo)) {
            const newData = companyInfoInit.map((office, index) => {
                const newKey = {}
                Object.keys(office).forEach((key) => {
                    let value = currCompanyInfo[index]?.[key]?.value || null;
                    if (key === 'link2' && typeof value === 'object' && value !== null) {
                        try {
                            value = JSON.stringify(value);
                        } catch (e) {
                            console.error("Error stringifying link2:", e);
                        }
                    }
                    newKey[key] = key == 'id' && index == 0 ? 'head_office' : key == 'id' && index == 1 ? 'vt_office' : value
                })
                return newKey
            })
            const response = await updateWebinf(newData[0])
            Swal.fire(
                response.results.status,
                response.results.msg,
                response.results.status
            )
            updateWebinf(newData[1])
        }
    }
    return (
        <>
            <Stack direction="row" spacing={2} mb={3}>

                <Typography fontWeight={'bold'} variant="h4">Company Infomations</Typography>
                <Button variant="text" onClick={() => { setOpen(!open) }}>{open ? 'Hide' : 'Show'}</Button>
            </Stack>
            <Box sx={{ minWidth: 800 }}>

                <Collapse in={open}>

                    <Box sx={{ width: '100%' }}>
                        <Typography component="h3" variant="h5" gutterBottom>
                            HO CHI MINH OFFICE
                        </Typography>
                        <Divider />
                        <br />
                        <Grid container>

                            {
                                companyInfo[0] && Object?.keys(companyInfo[0])?.map((key) => {
                                    let label = key
                                    if (key === 'link2') {
                                        const link2Value = companyInfo?.[0]?.[key]?.value || {};
                                        const fields = [
                                            { key: 'hotline', label: 'Hotline' },
                                            { key: 'main_email', label: 'Main Email' },
                                            { key: 'sale_phone', label: 'Sales Phone' },
                                            { key: 'sale_email', label: 'Sales Email' }
                                        ];
                                        return fields.map((field) => (
                                            <Grid item md={6} p={1} key={field.key}>
                                                <FormControl fullWidth={true}>
                                                    <TextField
                                                        InputLabelProps={{ shrink: true }}
                                                        label={field.label}
                                                        name={"head_link2_" + field.key}
                                                        onChange={(e) => { handleChange(e.target.value, 0, 'link2', field.key) }}
                                                        value={link2Value[field.key] || ''}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        ));
                                    }

                                    switch (key) {
                                        case 'link1':
                                            label = 'Facebook'
                                            break;
                                        case 'link3':
                                            label = 'Zalo'
                                            break;

                                        default:
                                            label = key
                                            break;
                                    }
                                    return (
                                        <Grid item md={6} p={1} key={key}>
                                            <FormControl required={true} fullWidth={true}>
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    required
                                                    label={label}
                                                    name={"head_" + key}
                                                    error={companyInfo?.[0]?.[key]?.invalid}
                                                    helperText={companyInfo?.[0]?.[key]?.msg}
                                                    onChange={(e) => { handleChange(e.target.value, 0, key) }}
                                                    value={companyInfo?.[0]?.[key]?.value}
                                                />
                                            </FormControl>
                                        </Grid>
                                    )
                                })
                            }
                        </Grid>

                        <br />
                        <Typography component="h3" variant="h5" gutterBottom>
                            Vung Tau Office
                        </Typography>
                        <Divider />
                        <br />
                        <form>
                            <Grid container>
                                {
                                    companyInfo[1] && Object?.keys(companyInfo[1])?.map((key) => {
                                        let label = key
                                        return (
                                            <Grid key={key} item md={6} p={1}>
                                                <FormControl required={true} fullWidth={true}>
                                                    <TextField
                                                        InputLabelProps={{ shrink: true }}
                                                        required
                                                        label={label}
                                                        name={"head_" + key}
                                                        error={companyInfo?.[1]?.[key]?.invalid}
                                                        helperText={companyInfo?.[1]?.[key]?.msg}
                                                        onChange={(e) => { handleChange(e.target.value, 1, key) }}
                                                        value={companyInfo?.[1]?.[key]?.value}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        )
                                    })
                                }
                            </Grid>
                        </form>
                    </Box>
                    <Box
                        sx={{ display: 'flex', justifyContent: 'flex-end' }}
                    >
                        <Button variant="contained" onClick={() => { handleUpdateWebinf(companyInfo, companyInfoInit) }}>Update</Button>
                    </Box>
                </Collapse>
            </Box>
        </>

    )
}


const validateData = (data) => {
    let check = true
    data.forEach((dt) => {
        Object.keys(dt).forEach(key => {
            if (dt[key].invalid) {
                check = false
            }
        });
    })
    return check
};

const isValidPhoneNumber = (number) => {
    return /((^(\+84|84|0|0084){1})(3|5|7|8|9))+([0-9]{8})$/.test(number);
};

const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

const isValidWebsiteLink = (websiteLink) => {
    return true
    const websiteRegex = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
    return websiteRegex.test(websiteLink);
};